export const toHHmm = (dateObject) => {
    if (!dateObject) {
        return null;
    }

    try {
        return dateObject.toLocaleTimeString("ru").slice(0, 5); // "HH:MM"
    } catch {
        return null;
    }
}

export const parseHHmmToDate = (hhmm) => {
    if (!hhmm) {
        return null;
    }

    // date part doesn't matter, only time
    return new Date(`December 1, 2023 ${hhmm}:00`);
}

export const buildTimeJson = (weekTime) => {
    // weekTime: array length 7 of [startDate | null, endDate | null]
    return weekTime.slice(0, 7).map((t, index) => ({
        day: index + 1,
        weekend: index >= 5,
        start: t?.[0] ? toHHmm(t[0]) : null,
        end: t?.[1] ? toHHmm(t[1]) : null,
    }));
}

export const applySingleWeek = (singleStart, singleEnd) => {
    const start = singleStart || null;
    const end = singleEnd || null;

    return Array.from({ length: 7 }).map(() => [start, end]);
}

export const inferScheduleType = (timeJson) => {
    // If Mon-Fri are identical and weekend empty -> single else week
    if (timeJson.length < 7) {
        return "week";
    }

    const first = timeJson[0];
    const allSame = timeJson.slice(0, 5)
        .every((d) => d?.start === first?.start && d?.end === first?.end);
    const weekendsEmpty = timeJson.slice(5, 7).every((d) => !d?.start && !d?.end);

    return allSame && weekendsEmpty ? "single" : "week";
}